import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
    FaBed, FaBath, FaRulerCombined, FaWhatsapp, FaPhoneAlt, 
    FaMapMarkerAlt, FaStar, FaArrowLeft, FaChevronLeft, 
    FaChevronRight, FaTimes, FaCheckCircle, FaFileAlt, FaIdCard,
    FaInfoCircle
} from 'react-icons/fa';
import '../css/PropertyDetails.css';

// Import local images (same as before)
import Property1Img1 from '../assets/Property1/1.jpeg';
import Property1Img2 from '../assets/Property1/2.jpeg';
import Property1Img3 from '../assets/Property1/3.jpeg';
import Property1Img4 from '../assets/Property1/4.jpeg';
import Property1Img5 from '../assets/Property1/5.jpeg';
import Property1Img6 from '../assets/Property1/6.jpeg';
import Property1Img7 from '../assets/Property1/7.jpeg';
import Property1Img8 from '../assets/Property1/8.jpeg';

import Property2Img1 from '../assets/Property2/1.jpeg';
import Property2Img2 from '../assets/Property2/2.jpeg';
import Property2Img3 from '../assets/Property2/3.jpeg';
import Property2Img4 from '../assets/Property2/4.jpeg';
import Property2Img5 from '../assets/Property2/5.jpeg';
import Property2Img6 from '../assets/Property2/6.jpeg';
import Property2Img7 from '../assets/Property2/7.jpeg';
import Property2Img8 from '../assets/Property2/8.jpeg';
import Property2Img9 from '../assets/Property2/9.jpeg';
import Property2Img10 from '../assets/Property2/10.jpeg';
import Property2Img11 from '../assets/Property2/11.jpeg';
import Property2Img12 from '../assets/Property2/12.jpeg';
import Property2Img13 from '../assets/Property2/13.jpeg';
import Property2Img14 from '../assets/Property2/14.jpeg';
import Property2Img15 from '../assets/Property2/15.jpeg';
import Property2Img16 from '../assets/Property2/16.jpeg';
import Property2Img17 from '../assets/Property2/17.jpeg';

import Property3Img1 from '../assets/Property3/1.jpeg';
import Property3Img2 from '../assets/Property3/2.jpeg';
import Property3Img3 from '../assets/Property3/3.jpeg';
import Property3Img4 from '../assets/Property3/4.jpeg';
import Property3Img5 from '../assets/Property3/5.jpeg';
import Property3Img6 from '../assets/Property3/6.jpeg';
import Property3Img7 from '../assets/Property3/7.jpeg';
import Property3Img8 from '../assets/Property3/8.jpeg';
import Property3Img9 from '../assets/Property3/9.jpeg';
import Property3Img10 from '../assets/Property3/10.jpeg';
import Property3Img11 from '../assets/Property3/11.jpeg';
import Property3Img12 from '../assets/Property3/12.jpeg';
import Property3Img13 from '../assets/Property3/13.jpeg';

import Property4Img1 from '../assets/Property4/1.jpeg';
import Property4Img2 from '../assets/Property4/2.jpeg';
import Property4Img3 from '../assets/Property4/3.jpeg';
import Property4Img4 from '../assets/Property4/4.jpeg';
import Property4Img5 from '../assets/Property4/5.jpeg';
import Property4Img6 from '../assets/Property4/6.jpeg';
import Property4Img7 from '../assets/Property4/7.jpeg';
import Property4Img8 from '../assets/Property4/8.jpeg';
import Property4Img9 from '../assets/Property4/9.jpeg';
import Property4Img10 from '../assets/Property4/10.jpeg';
import Property4Img11 from '../assets/Property4/11.jpeg';
import Property4Img12 from '../assets/Property4/12.jpeg';
import Property4Img13 from '../assets/Property4/13.jpeg';
import Property4Img14 from '../assets/Property4/14.jpeg';

const PropertyDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [property, setProperty] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedImage, setSelectedImage] = useState(0);
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [autoSlide, setAutoSlide] = useState(true);

    const properties = [
        {
            id: 1,
            title: "The Royal Haven - Malad East",
            location: "Malad East, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "950 sq ft",
            rating: 4.9,
            category: "malad",
            images: [
                Property1Img1, Property1Img2, Property1Img3, Property1Img4,
                Property1Img5, Property1Img6, Property1Img7, Property1Img8
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: true,
            bestDeal: true,
            description: "Experience unparalleled luxury at The Royal Haven. This premium girls' PG accommodation features elegant interiors, state-of-the-art amenities, and 24/7 personalized service. Located in the heart of Malad East with easy access to metro, shopping malls, and entertainment zones.",
            address: "Pandit Solicitor Road, Opposite Blue Diamond, Malad East, Mumbai - 400097",
            agreement: "Agreement",
            policeVerification: ""
        },
        {
            id: 2,
            title: "The Grand Suite - Malad East",
            location: "Malad West, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "940 sq ft",
            rating: 4.8,
            category: "malad",
            images: [
                Property2Img1, Property2Img2, Property2Img3, Property2Img4,
                Property2Img5, Property2Img6, Property2Img7, Property2Img8,
                Property2Img9, Property2Img10, Property2Img11, Property2Img12,
                Property2Img13, Property2Img14, Property2Img15, Property2Img16, Property2Img17
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: true,
            bestDeal: false,
            description: "Indulge in the finest living experience at The Grand Suite. This exquisite PG offers spacious deluxe rooms with premium furnishings, ensuite bathrooms, and breathtaking city views. Located in prime Malad West with excellent connectivity.",
            address: "Near Inorbit Mall, Malad West, Mumbai - 400064",
            agreement: "Agreement",
            policeVerification: ""
        },
        {
            id: 3,
            title: "The Executive Tower - Goregaon East",
            location: "Goregaon East, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "925 sq ft",
            rating: 5.0,
            category: "goregaon",
            images: [
                Property3Img1, Property3Img2, Property3Img3, Property3Img4,
                Property3Img5, Property3Img6, Property3Img7, Property3Img8,
                Property3Img9, Property3Img10, Property3Img11, Property3Img12, Property3Img13
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: true,
            bestDeal: true,
            description: "Designed for the modern executive, this premium PG offers unmatched sophistication. Enjoy spacious rooms, dedicated workspace, premium bedding, and access to exclusive common areas. Perfect for working professionals and business travelers.",
            address: "Near Oberoi Mall, Goregaon East, Mumbai - 400063",
            agreement: "Agreement",
            policeVerification: ""
        },
        {
            id: 4,
            title: "The Elite Residence - Goregaon East",
            location: "Goregaon West, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "920 sq ft",
            rating: 4.9,
            category: "goregaon",
            images: [
                Property4Img1, Property4Img2, Property4Img3, Property4Img4,
                Property4Img5, Property4Img6, Property4Img7, Property4Img8,
                Property4Img9, Property4Img10, Property4Img11, Property4Img12, Property4Img13, Property4Img14
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: false,
            bestDeal: true,
            description: "Elevate your lifestyle at The Elite Residence. This meticulously curated PG offers the perfect blend of luxury and convenience. From designer interiors to world-class amenities, every detail speaks of excellence.",
            address: "Link Road, Goregaon West, Mumbai - 400062",
            agreement: "Agreement",
            policeVerification: ""
        }
    ];

    useEffect(() => {
        const foundProperty = properties.find(p => p.id === parseInt(id));
        if (foundProperty) {
            setProperty(foundProperty);
        }
        setLoading(false);
        window.scrollTo(0, 0);
    }, [id]);

    // Auto-slide gallery
    useEffect(() => {
        let interval;
        
        if (autoSlide && property) {
            interval = setInterval(() => {
                setSelectedImage((prev) => (prev + 1) % property.images.length);
            }, 4000);
        }
        
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [autoSlide, property]);

    const handleUserInteraction = () => {
        setAutoSlide(false);
        setTimeout(() => {
            setAutoSlide(true);
        }, 10000);
    };

    const openLightbox = (index) => {
        setLightboxIndex(index);
        setIsLightboxOpen(true);
        document.body.style.overflow = 'hidden';
        handleUserInteraction();
    };

    const closeLightbox = () => {
        setIsLightboxOpen(false);
        document.body.style.overflow = 'unset';
    };

    const nextImage = () => {
        setLightboxIndex((prev) => (prev + 1) % property.images.length);
        handleUserInteraction();
    };

    const prevImage = () => {
        setLightboxIndex((prev) => (prev - 1 + property.images.length) % property.images.length);
        handleUserInteraction();
    };

    const handleWhatsAppInquiry = () => {
        const message = `🏠 *PG INQUIRY* 🏠%0A%0A` +
            `━━━━━━━━━━━━━━━━━━━━━━%0A` +
            `✨ *Property:* ${property.title}%0A` +
            `📍 *Location:* ${property.location}%0A` +
            `🏠 *Area:* ${property.area}%0A` +
            `🛏️ *Bedrooms:* ${property.bedrooms}%0A` +
            `━━━━━━━━━━━━━━━━━━━━━━%0A` +
            `🌟 *I'm interested in this property. Please contact me!* 🌟`;
        
        window.open(`https://wa.me/918879779777?text=${encodeURIComponent(message)}`, '_blank');
    };

    const handleCallInquiry = () => {
        window.open('tel:+918879779777', '_blank');
    };

    if (loading) {
        return (
            <div className="prop-details-loading">
                <div className="loader"></div>
                <p>Loading luxury property...</p>
            </div>
        );
    }

    if (!property) {
        return (
            <div className="prop-details-not-found">
                <h2>Property Not Found</h2>
                <button onClick={() => navigate('/properties')}>Back to Properties</button>
            </div>
        );
    }

    return (
        <div className="prop-details-page">
            {/* Back Button */}
            <button className="prop-details-back-btn" onClick={() => navigate('/properties')}>
                <FaArrowLeft />
                <span>Back to Properties</span>
            </button>

            {/* Gallery Section */}
            <div className="prop-details-gallery">
                <div className="prop-gallery-main" onClick={() => openLightbox(selectedImage)}>
                    <img 
                        src={property.images[selectedImage]} 
                        alt={property.title}
                    />
                    {autoSlide && (
                        <div className="prop-auto-slide-indicator">
                            <div className="auto-slide-progress" />
                        </div>
                    )}
                </div>
                <div className="prop-gallery-thumbnails">
                    {property.images.map((image, index) => (
                        <div 
                            key={index}
                            className={`prop-gallery-thumb ${selectedImage === index ? 'active' : ''}`}
                            onClick={() => { setSelectedImage(index); handleUserInteraction(); }}
                        >
                            <img src={image} alt={`Thumbnail ${index + 1}`} />
                        </div>
                    ))}
                </div>
                
                <div className="prop-auto-slide-control">
                    <button 
                        className={`auto-slide-btn ${autoSlide ? 'active' : ''}`}
                        onClick={() => setAutoSlide(!autoSlide)}
                    >
                        {autoSlide ? '⏸ Pause' : '▶ Play'}
                    </button>
                </div>
            </div>

            {/* Content Grid */}
            <div className="prop-details-content-grid">
                {/* Left Column */}
                <div className="prop-details-left">
                    <div className="prop-details-header">
                        <h1>{property.title}</h1>
                        <div className="prop-details-location">
                            <FaMapMarkerAlt />
                            <span>{property.address}</span>
                        </div>
                        <div className="prop-details-rating">
                            <FaStar />
                            <span>{property.rating}</span>
                            <span className="rating-text">Excellent</span>
                        </div>
                        
                        <div className="prop-details-buttons">
                            <button className="prop-details-book-btn" onClick={handleWhatsAppInquiry}>
                                <FaWhatsapp />
                                <span>Book Now</span>
                            </button>
                            <button className="prop-details-call-btn" onClick={handleCallInquiry}>
                                <FaPhoneAlt />
                                <span>Call Now</span>
                            </button>
                        </div>
                    </div>

                    <div className="prop-details-specs">
                        <div className="spec">
                            <FaBed />
                            <span>{property.bedrooms} Bedrooms</span>
                        </div>
                        <div className="spec">
                            <FaBath />
                            <span>{property.bathrooms} Bathrooms</span>
                        </div>
                        <div className="spec">
                            <FaRulerCombined />
                            <span>{property.area}</span>
                        </div>
                    </div>

                    <div className="prop-details-description">
                        <h3>Description</h3>
                        <p>{property.description}</p>
                    </div>

                    <div className="prop-details-amenities">
                        <h3>💁‍♀️ AMENITIES</h3>
                        <div className="amenities-grid">
                            {property.amenities.map((amenity, index) => (
                                <div key={index} className="amenity-item">
                                    <FaCheckCircle className="amenity-check" />
                                    <span>{amenity}</span>
                                </div>
                            ))}
                        </div>
                        <div className="amenities-included">
                            <p className="all-included">✨ All Included ✨</p>
                        </div>
                    </div>

                    <div className="prop-details-agreement">
                        <h3>📝 Agreement</h3>
                        <div className="agreement-content">
                            <FaFileAlt />
                            <span>{property.agreement}</span>
                        </div>
                        <div className="police-verification">
                            <FaIdCard />
                            <span>🔎 Police Verification {property.policeVerification}</span>
                        </div>
                    </div>
                </div>

                {/* Right Column - Info Message Instead of Nearby & Rules */}
                <div className="prop-details-right">
                    <div className="prop-info-message">
                        <div className="info-icon-wrapper">
                            <FaInfoCircle />
                        </div>
                        <h3>📋 Need More Details?</h3>
                        <p>
                            For detailed information about nearby landmarks, house rules, and other specific requirements, 
                            please feel free to <strong>contact us</strong> or <strong>WhatsApp us</strong>. 
                            Our team will be happy to assist you with all the details you need.
                        </p>
                        <div className="info-buttons">
                            <button className="info-whatsapp-btn" onClick={handleWhatsAppInquiry}>
                                <FaWhatsapp />
                                <span>WhatsApp Us</span>
                            </button>
                            <button className="info-call-btn" onClick={handleCallInquiry}>
                                <FaPhoneAlt />
                                <span>Call Us</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lightbox Modal */}
            {isLightboxOpen && (
                <div className="prop-lightbox" onClick={closeLightbox}>
                    <button className="lightbox-close" onClick={closeLightbox}>
                        <FaTimes />
                    </button>
                    <button className="lightbox-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>
                        <FaChevronLeft />
                    </button>
                    <button className="lightbox-next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>
                        <FaChevronRight />
                    </button>
                    <img 
                        src={property.images[lightboxIndex]} 
                        alt={`${property.title} - Image ${lightboxIndex + 1}`}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <div className="lightbox-counter">
                        {lightboxIndex + 1} / {property.images.length}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PropertyDetails;